import type { CartItems } from '#lib/features/checkout/utils/createCartItemsStore/index.js';
import { browser } from '$app/env';

export const PRIMARY_CART_ITEMS_KEY = 'primary-cart-items';

/**
 * Copies cart items belonging to a specific drop (by groupId/dropCode)
 * from the shared `primary-cart-items` store to a drop-specific
 * `primary-{dropPageSlug}-cart-items` store.
 *
 * This is used on the checkout page for non-generic purchase drops
 * so that the checkout reads from its own isolated cart store.
 */
export const copyCartItemsForDrop = (
	dropPageSlug: string,
	dropCode: string
) => {
	if (!browser) return;

	try {
		const targetKey = `primary-${dropPageSlug}-cart-items`;

		const sourceData = localStorage.getItem(PRIMARY_CART_ITEMS_KEY);
		if (!sourceData) return;

		const sourceItems: CartItems = JSON.parse(sourceData);

		const itemsForDrop = Object.entries(sourceItems).reduce(
			(acc, [productId, item]) => {
				if (item.groupId === dropCode) {
					acc[productId] = item;
				}
				return acc;
			},
			{} as CartItems
		);

		if (Object.keys(itemsForDrop).length > 0) {
			localStorage.setItem(targetKey, JSON.stringify(itemsForDrop));
		}
	} catch {
		// localStorage may not be available
	}
};
